// extracted by mini-css-extract-plugin
export default {"aboutPage":"AboutPage_aboutPage__7g2T6","titleAbout":"AboutPage_titleAbout__r-DF1"};